import React, { useState } from 'react';
import { X, Check, X as XIcon } from 'lucide-react';

const TimePickerModal = ({ isOpen, onClose, onConfirm }) => {
  const [timeInput, setTimeInput] = useState('');

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (timeInput.trim()) {
      onConfirm(timeInput.trim());
      setTimeInput('');
    } else {
      alert('请输入时间');
    }
  };

  const handleCancel = () => {
    setTimeInput('');
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content max-w-md">
        <div className="modal-header">
          <h2 className="modal-title">添加时间</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors duration-200 p-2 rounded-full hover:bg-gray-100 flex items-center justify-center"
          >
            <X size={18} />
          </button>
        </div>
        
        <div className="modal-body">
          <p className="text-gray-700 mb-4">请输入时间格式，例如：09:00-09:45</p>
          <input
            type="text"
            value={timeInput}
            onChange={(e) => setTimeInput(e.target.value)}
            placeholder="例如：09:00-09:45"
            className="w-full p-3 border-2 border-gray-300 rounded-lg text-sm transition-colors duration-300 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-200"
          />
        </div>
        
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={handleConfirm}>
            <Check size={16} className="mr-2" />
            确认
          </button>
          <button className="btn btn-danger" onClick={handleCancel}>
            <XIcon size={16} className="mr-2" />
            取消
          </button>
        </div>
      </div>
    </div>
  );
};

export default TimePickerModal;
